<template>
	<div style="min-width: 600px;">
		<!-- {{date1}} -->
        <div class="row align-items-center">
            <div class="d-flex align-items-center m-1" style="width: 200px;">
                <b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" today-button close-button locale="zh"></b-form-datepicker>
            </div>
            <div class="d-flex align-items-center m-1" style="width: 130px;">
                <b-form-select size="sm" v-model="show_top_n" :options="topNOptions"></b-form-select>
            </div>
            <div class="d-flex align-items-center m-1" style="width: 100px;">
                <b-form-checkbox
                id="checkbox_show_up_success"
                v-model.number="status_only_up_success"
                name="checkbox_show_up_success"
                value="1"
                unchecked-value="0"
                size="sm"
                @click="click_show_up_success"
                >
                只要晋级
                </b-form-checkbox>
            </div>
            <div class="d-flex align-items-center m-1" style="width: 90px;">
                <b-form-checkbox
                id="checkbox_show_promotion_rate"
                v-model.number="show_promotion_rate"
                name="checkbox_show_promotion_rate"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                晋级率
                </b-form-checkbox>
            </div>
            <div class="d-flex align-items-center m-1" style="width: 100px;">
                <b-form-checkbox
                id="checkbox_show_min_chart"
                v-model.number="show_min_chart"
                name="checkbox_show_min_chart"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                分时
                </b-form-checkbox>
            </div>
            
        </div>

		<div class="row">
			<div class="col-1 border alert-primary">梯队/板块</div>
			<div class="col alert-danger border" v-bind:key="plate.index" v-for="plate in plates">
				{{plate['name']}}
			</div>
		</div>

        <div class="row" v-bind:key="ban.index" v-for="ban in bans">
            <div v-if="ban==0" class="col-1 border alert-danger">炸 板 <span v-if="show_promotion_rate" class="badge badge-info">{{ getBanPromotionStat(ban) }}</span></div>
            <div v-else class="col-1 border alert-danger">{{ban}} 板 <span v-if="show_promotion_rate" class="badge badge-info">{{ getBanPromotionStat(ban) }}</span></div>
			
			<div class="col border" style="padding: 0;" v-bind:key="plate.index" v-for="plate in plates">
				<!-- {{ban}} {{plate['code']}} {{stocks_plate[ban][plate['code']]}} -->
				<div class="stock_item_block" v-bind:key="stock.index" v-for="stock in stocks_plate[ban][plate['code']]">
					<!-- {{stock["up_limit_time"]}} {{stock['stock_name']}} {{stock['next_close_pct']}} -->
					<StockTextNextDayItem @show_sidebar="show_sidebar" :only_up_success="status_only_up_success"  :stock_info="stock"></StockTextNextDayItem>
                    <div v-if="show_min_chart" :data-stock-code="stock.stock_code" style="min-height: 50px;">
                         <StockMiniTrend v-if="visibleStocks[stock.stock_code]" :symbol_code="stock.stock_code" :selected_date="getNextTradingDay(date1)" :key="stock.stock_code"></StockMiniTrend>
                         <div v-else class="d-flex justify-content-center align-items-center" style="height: 50px; background: #f8f9fa;">
                            <span class="text-muted small" style="font-size: 10px;">载入中...</span>
                        </div>
                    </div>
				</div>
			</div>
		</div>
		
		
	</div>
</template>

<script>
	import StockTextNextDayItem from 'components/stock/StockTextNextDayItem.vue'
    import StockMiniTrend from 'components/stock/StockMiniTrend.vue'

import {
    request_zzquant,request_zrx
} from "network/request.js"
	
	export default {
		props:{
			// status_market:{type:Number,default:0}	
		},
		components: {
			StockTextNextDayItem,
            StockMiniTrend
		},
        mounted() {
            // console.log("mounted");
            // this.update_info();
            request_zrx({url:'/open/tradedays'}).then(
                res => {
                    let days = res['data']['data']
                    // console.log(days);
                    this.all_trading_days = days;
                    this.last_trade_day = days[days.length-1];
                    this.date1 = days[days.length-2];
                    const savedShowTopN = localStorage.getItem('uplimit_show_top_n');
                    if (savedShowTopN !== null) {
                        this.show_top_n = parseInt(savedShowTopN);
                    }
                    const savedShowPromotionRate = localStorage.getItem('uplimit_show_promotion_rate_nextday');
                    if (savedShowPromotionRate !== null) {
                        this.show_promotion_rate = parseInt(savedShowPromotionRate);
                    }
                    this.update_info(this.date1);
                }
            );
        },
        beforeDestroy() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },
        watch:{
            // status_market:this.update_info
            show_top_n(newVal) {
                localStorage.setItem('uplimit_show_top_n', newVal);
                this.update_info(this.date1);
            },
            show_promotion_rate(newVal) {
                localStorage.setItem('uplimit_show_promotion_rate_nextday', newVal);
            },
            show_min_chart(val) {
                if (val) {
                    this.initObserver();
                } else {
                    if (this.observer) {
                        this.observer.disconnect();
                        this.observer = null;
                    }
                    this.visibleStocks = {};
                }
            },
            stocks_plate: {
                handler() {
                     if (this.show_min_chart) {
                        this.observeStockRows();
                    }
                },
                deep: true
            }
        },
        data() {
            const now = new Date();
            const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
            return {
                show_min_chart: 0,
                visibleStocks: {},
                observer: null,
                status_only_up_success: 0,
                date1: today,
                last_trade_day: '',
                all_trading_days: [],
                show_top_n: 12,
                topNOptions: [
                    { value: 5, text: '显示板块: 5个' },
                    { value: 8, text: '显示板块: 8个' },
                    { value: 10, text: '显示板块: 10个' },
                    { value: 12, text: '显示板块: 12个' },
                    { value: 15, text: '显示板块: 15个' },
                    { value: 20, text: '显示板块: 20个' }
                ],
                show_promotion_rate: 1,
                bans: [5, 4, 3, "炸"],
                plates: [{
                    "name": "loading...",
                    "code": "8001"
                }, {
					"name": "loading...",
					"code": "8003"
				}, {
					"name": "loading...",
					"code": "8003"
				}],
				stocks_plate: {
					"5": {
						"8001": [{
							"stock_name": "loading...",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [{
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}],
					},
					"4": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
					"3": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
					"炸": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:50",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
				},
			};
		},

        methods: {
			getNextTradingDay(dateStr) {
				if (!this.all_trading_days || this.all_trading_days.length === 0) return dateStr;
				const idx = this.all_trading_days.indexOf(dateStr);
				if (idx > -1 && idx < this.all_trading_days.length - 1) {
					return this.all_trading_days[idx + 1];
				}
				return dateStr;
			},
            initObserver() {
                if (this.observer) {
                    this.observer.disconnect();
                }
                this.observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const stockCode = entry.target.dataset.stockCode;
                            if (stockCode && !this.visibleStocks[stockCode]) {
                                this.$set(this.visibleStocks, stockCode, true);
                                this.observer.unobserve(entry.target);
                            }
                        }
                    });
                }, {
                    rootMargin: '100px'
                });
                this.observeStockRows();
            },
            observeStockRows() {
                if (!this.show_min_chart) return;
                this.$nextTick(() => {
                    const rows = this.$el.querySelectorAll('.stock_item_block > div[data-stock-code]');
                    rows.forEach(row => {
                        if (row) this.observer.observe(row);
                    });
                });
            },
            show_sidebar(stock_info){
                this.$emit('show_sidebar',stock_info)
            },
            getBanPromotionStat(ban){
                const plateDict = this.stocks_plate && this.stocks_plate[ban]
                if(!plateDict) return ''
                const seen = new Set()
                let success = 0
                let total = 0
                Object.keys(plateDict).forEach(code => {
                    const arr = plateDict[code] || []
                    arr.forEach(item => {
                        const sc = item && item['stock_code']
                        if(!sc) return
                        if(seen.has(sc)) return
                        seen.add(sc)
                        total += 1
                        const pct = Number(item['next_close_pct'])
                        if(pct > 9.5) success += 1
                    })
                })
                if(total===0) return ''
                const rate = ((success / total) * 100).toFixed(0)
                return rate + '% (' + success + '/' + total + ')'
            },
            click_show_up_success(){
                // console.log("click");
                this.update_info(this.date1);
            },
			onDatePicked(ctx) {
				// console.log(ctx.selectedYMD);
				this.date1 = ctx.selectedYMD;
				// console.log(this.date1);
				this.update_info(this.date1);
			},
            dateDisabled(ymd, date) {
                const weekday = date.getDay();
                const time = date.getTime()

                const now = new Date();
                const now_time = now.getTime();
                // 禁用最后一个交易日（次日数据尚未生成）
                if (this.last_trade_day && ymd === this.last_trade_day) {
                    return true;
                }
                // 周六日不能选
                if (weekday === 0 || weekday === 6) {
                    return true;
                }
                //今天之后不能选
                if (time >= now_time) {
                    return true;
                }
                return false
            },
			real_time_info_stock(real_time_stocks,stock) {
				
				if(!real_time_stocks) return false;
				
				var fields = real_time_stocks['fields']
				var values = real_time_stocks['values']
				
				var idx = fields.indexOf(stock)
				// console.log(fields,values,stock,idx);
				if(idx > -1){
					return values[idx]
				}
				return false
			},
			update_table_info(res,res2){
				// console.log(res2);
				let data = res['data']['data'];
				let plates = data['plate'];
				let plate_stocks = data['plate_stocks']
				// 更新板块显示
				let plate_arr = [];
                plates.forEach((item, idx) => {
                    if (idx >= this.show_top_n) return
                    plate_arr.push({
                        "name": item[0],
                        "code": item[1],
                        "score": item[2]
                    })
                });
				// // 添加其他版块
				// plate_arr.push({
				// 	"name": '其他',
				// 	"code": '000000',
				// 	"score": 0
				// })
				this.plates = plate_arr;
				
				// 更新最高板数梯队
				let ban_arr = [];
				for (let i = data.max_count; i > -1; i--) {
					ban_arr.push(i);
				}
				// ban_arr.push(0)
				this.bans = ban_arr;
				
				// 更新板块下的股票列表
				let stocks_plate_dict = {};
				
				for (let idx in ban_arr) { //从高到低的板数梯队
					let ban = ban_arr[idx]
					stocks_plate_dict[ban] = {}
					plates.forEach((item) => {
						let plate_code = item[1]
						stocks_plate_dict[ban][plate_code] = [] //某板块下的数据
						let stocks_on_plate = plate_stocks[plate_code] //股票列表
						stocks_on_plate.forEach((item2) => {
							if (item2['up_limit_keep_times'] == ban) {
								if(this.status_market==1 && res2){
									let market = this.real_time_info_stock(res2['data']['data'],item2['stock_code']);
									// console.log(market);
									item2['market']  = market;
								}else{
									item2['market']  = {"px_change_rate":0,"open_px_rate":0}
								}
								stocks_plate_dict[ban][plate_code].push(item2)
								// console.log(ban,plate_code,stocks_plate_dict[ban][plate_code]);
							}
						})
					});
				}
				this.stocks_plate = stocks_plate_dict;
			},
			update_info(date1) {
				// console.log(self.date1);
                request_zzquant({
                    url: 'v3/open/review/uplimit/hot?date1=' + date1+ '&limit=' + this.show_top_n,
                }).then(res => {
					if(this.status_market==1){
						let data = res['data']['data'];
						if(data['stocks'] && data['stocks'].length > 0) {
						request_zrx({
							url: '/open/market/real?symbols='+data['stocks']
						}).then(res2 => {
							this.update_table_info(res,res2);
						})}
					}else{
						this.update_table_info(res)
					}
				})
			}
		},

	}
</script>

<style>
.stock_item_block{
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	font-size: 14px;
	line-height: 1.42857143;
	color: #333;
	background-color: #fff;
	margin-left: 0px;
	/* border: 1px solid #EC0000; */
}
</style>
